module.exports = __webpack_public_path__ + "static/fun-time/games/page040_game2/audio//M_Work harder.mp3";